import { generatePath, NavLink } from 'react-router-dom';

import { formatDate, IconRight } from '@ui/src';
import {
  CofProps,
  CofStatus,
  NatureOfControlEnum,
  NewApplicationStatus,
  SignatureType,
} from '../../../hoc/customers/types';
import { getCofApplicationStatus, getCofStatus } from './helpers';
import { AccessRight } from '../../../hoc/corporate/types';

import ROUTES from '../../../routes';

import cn from './overview.module.css';

const getSignatureType = (type: SignatureType) => {
  let signatureType: string;

  switch (type) {
    case SignatureType.NONE:
      signatureType = 'None';
      break;
    case SignatureType.SINGLE:
      signatureType = 'Single';
      break;
    default:
      signatureType = type;
      break;
  }

  return signatureType;
};

const getAccessRight = (type: AccessRight) => {
  let signatureType: string;

  switch (type) {
    case AccessRight.NONE:
      signatureType = 'None';
      break;
    case AccessRight.VIEWER:
      signatureType = 'Viewer';
      break;
    default:
      signatureType = type;
      break;
  }

  return signatureType;
};

const CompanyOfficialListItem = ({ item }: { item: CofProps }) => {
  let natureOfControl;

  if (item.natureOfControl === NatureOfControlEnum.DIRECT_CONTROL) {
    natureOfControl = 'Direct control';
  } else {
    natureOfControl = 'Indirect control';
  }

  let type;

  if (item.officialApplication?.status !== NewApplicationStatus.ACCEPTED) {
    type = 'Application';

    if (
      item.status === CofStatus.ARCHIVED ||
      item.status === CofStatus.REJECTED
    ) {
      if (item.companyOfficialType === 'MAIN_REPRESENTATIVE') {
        type = 'Main representative';
      } else if (item.companyOfficialType === 'COMPANY_OFFICIAL') {
        type = 'Company official';
      }
    }
  } else if (
    item.officialApplication?.status === NewApplicationStatus.ACCEPTED
  ) {
    if (item.companyOfficialType === 'MAIN_REPRESENTATIVE') {
      type = 'Main representative';
    } else if (item.companyOfficialType === 'COMPANY_OFFICIAL') {
      type = 'Company official';
    }
  }

  const { cofStatus, cofStatusClassName } = getCofStatus(item.status);

  const { applicationStatus, applicationStatusClassName } =
    getCofApplicationStatus(
      item.officialApplication?.status as NewApplicationStatus,
    );

  let link: string;

  if (item.officialApplication?.status === NewApplicationStatus.ACCEPTED) {
    link = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
      customerId: (item?.user?.organization?.id as string) || '',
    });
  } else {
    link = generatePath(ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO, {
      applicationId: (item?.officialApplication?.id as string) || '',
    });

    if (item?.officialApplication?.type === 'COMPANY_OFFICIAL') {
      link = generatePath(ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL, {
        applicationId: item?.officialApplication?.id || '',
      });
    }
  }

  return (
    <NavLink to={link} target="_blank" className={cn.companyOfficialItem}>
      <div className={cn.companyOfficialLeft}>
        <div className={cn.companyOfficialName}>
          {`${item?.officialApplication?.firstName} ${item?.officialApplication?.lastName}`}

          <IconRight />
        </div>
        <div className={cn.companyOfficialPosition}>{item.position}</div>
      </div>
      <div className={cn.companyOfficialRight}>
        <div className={`${cn.companyOfficialValue} ${cn.companyOfficialDate}`}>
          {formatDate(item.createdAt)}
        </div>
        <div
          className={`${cn.companyOfficialValue} ${cn.companyOfficialStatus}`}
        >
          {`${type}: `}
          <span
            className={
              item.officialApplication?.status !==
                NewApplicationStatus.ACCEPTED &&
              item.status !== CofStatus.REJECTED &&
              item.status !== CofStatus.ARCHIVED
                ? applicationStatusClassName
                : cofStatusClassName
            }
          >
            {item.officialApplication?.status !==
              NewApplicationStatus.ACCEPTED &&
            item.status !== CofStatus.REJECTED &&
            item.status !== CofStatus.ARCHIVED
              ? applicationStatus
              : cofStatus}
          </span>
          <div
            className={cn.signatureType}
          >{`Signature type: ${getSignatureType(item.signatureType)}`}</div>
        </div>
        <div
          className={`${cn.companyOfficialValue} ${cn.companyOfficialPercentage}`}
        >
          {item.percentage ? `${item.percentage}%` : ''}
        </div>
        <div
          className={`${cn.companyOfficialValue} ${cn.companyOfficialNatureOfControl}`}
        >
          {item.natureOfControl ? natureOfControl : ''}
        </div>
        <div className={`${cn.companyOfficialValue} ${cn.companyOfficialRole}`}>
          {`Access Right: ${
            item.accessRight ? getAccessRight(item.accessRight) : 'None'
          }`}
          <span className={cn.companyOfficialHint}>i</span>
        </div>
      </div>
    </NavLink>
  );
};

export default CompanyOfficialListItem;
